import { render, staticRenderFns } from "./PostState.vue?vue&type=template&id=54050cb0&"
import script from "./PostState.vue?vue&type=script&lang=js&"
export * from "./PostState.vue?vue&type=script&lang=js&"
import style0 from "./PostState.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports